import router from "../router";

const navTo = (path: any, data: any) => {
  // console.log(path);
  router.push({
    path,
    query: data,
  });
};

/**
 * 判断是否是移动端
 * @returns 
 */
const isMobie = () => {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  if (flag) {
    // console.log('移动端打开');
    return true
  } else {
    // console.log("PC端打开")
    return false
  }
}

export { navTo, isMobie };
